import React from 'react';
import { useTranslation } from 'react-i18next';
import videoEng from '../assets/videos/OWLEX-ENG.mp4';
import videoTr from '../assets/videos/OWLEX-TR.mp4';
import '../styles/Header.css';

const Header = () => {
  const { t, i18n } = useTranslation();
  const video = i18n.language === 'tr' ? videoTr : videoEng;

  return (
    <section className="header">
      <div className="header-container">
        {/* Sol Taraf - Metin */}
        <div className="header-left">
          <h1 className="header-title">
            {t('header.title')}
          </h1>
          <p className="header-description">
            {t('header.description')}
          </p>
        </div>

        {/* Sağ Taraf - Video */}
        <div className="header-right">
          <video 
            key={i18n.language}
            className="header-video" 
            controls
            playsInline
          >
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
};

export default Header;

